module.exports = __webpack_public_path__ + "static/media/result.0a83921e.svg";